<template>
    <div class="objective-landing-page">
        <div class="objective-landing-page__content">
            <div class="objective-landing-page__content--title">
                <h1 class="typographies-display-brand-large">
                    {{ $l10n.__('Maximisez vos objectifs commerciaux') }}
                </h1>
                <ImgSvg class="underline" width="193px" height="9px">
                    <Underline />
                </ImgSvg>
            </div>

            <div class="objective-landing-page__content--informations">
                <p
                    class="typographies-paragraph-large-regular"
                    v-html="
                        $t.__('objectives.landing.ObjectiveLandingPage.informations_line_1', {
                            startStrong: '<span class=\'typographies-paragraph-large-bold\'>',
                            endStrong: '</span>',
                        })
                    "
                />

                <p
                    class="typographies-paragraph-large-regular"
                    v-html="
                        $t.__('objectives.landing.ObjectiveLandingPage.informations_line_2', {
                            startStrong: '<span class=\'typographies-paragraph-large-bold\'>',
                            endStrong: '</span>',
                        })
                    "
                />

                <p
                    class="typographies-paragraph-large-regular"
                    v-html="
                        $t.__('objectives.landing.ObjectiveLandingPage.informations_line_3', {
                            startStrong: '<span class=\'typographies-paragraph-large-bold\'>',
                            endStrong: '</span>',
                        })
                    "
                />
            </div>

            <div class="objective-landing-page__content--buttons">
                <CompassButton
                    :label="$t.__('common.actions.contact_sales')"
                    size="large"
                    @click="openIntercom"
                />
            </div>
        </div>

        <div class="objective-landing-page__illustration">
            <img src="/ressources/logged/img/illustrations/objective-widget-illustration.png" />
        </div>
    </div>
</template>

<script>
import ImgSvg from 'vcomponents/imgs/ImgSvg.vue';
import Underline from 'vcomponents/imgs/ImgUnderlineUltraBlueMarine.vue';

export default {
    components: {
        Underline,
        ImgSvg,
    },
    methods: {
        openIntercom() {
            window.Intercom('show');
        },
    },
};
</script>

<style lang="scss" scoped>
.objective-landing-page {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 137px;

    &__content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-6);
        width: 426px;

        &--title {
            h1 {
                color: var(--colors-common-text-brand-secondary-blue);
                margin: 0;
            }
        }

        &--informations {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-3);

            p {
                color: var(--colors-common-text-brand-secondary-blue);
                margin: 0;
                padding: 0 var(--spacing-1);

                &:not(:last-child) {
                    padding-bottom: var(--spacing-3);
                    border-bottom: 1px solid var(--colors-common-border-default);
                }
            }
        }

        &--buttons {
            display: flex;
            gap: var(--spacing-1);
        }
    }

    &__illustration {
        width: 539px;

        img {
            height: auto;
            max-width: 100%;
            object-fit: contain;
        }
    }
}
</style>
